import { render } from "./EventPayment.vue?vue&type=template&id=0ff27286&scoped=true"
import script from "./EventPayment.vue?vue&type=script&lang=js"
export * from "./EventPayment.vue?vue&type=script&lang=js"

import "./EventPayment.vue?vue&type=style&index=0&id=0ff27286&scoped=true&lang=scss"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff27286"]])

export default __exports__